import { render } from "./StorageRules.vue?vue&type=template&id=003baa18"
import script from "./StorageRules.vue?vue&type=script&lang=js"
export * from "./StorageRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__